module.exports = __webpack_public_path__ + "img/bag3.d2885753.png";